// Selo de Criador Parceiro — a arte oficial (estrela + pessoa no círculo azul).
//
// iconCriador.webp é o Assets/icons/iconCriador.png recortado no círculo e
// reduzido a 256 px (15 KB; o original tem 978 KB), suficiente até 96 px em
// tela 2x. Todos os lugares do app (avatar, ao lado do nome, feed, link,
// /assinar, verificação) usam este componente.

import React from "react";
import iconCriador from "../../Assets/icons/iconCriador.webp";

export default function SeloCriador({ size = 24, glow, className, title = "Criador Parceiro" }) {
  const s = Number(size) || 24;
  const comGlow = glow ?? s >= 48;
  return (
    <img
      src={iconCriador}
      alt={title}
      width={s}
      height={s}
      draggable={false}
      className={className}
      style={{
        width: s,
        height: s,
        flex: "none",
        display: "inline-block",
        verticalAlign: "middle",
        filter: comGlow ? `drop-shadow(0 0 ${Math.round(s * 0.25)}px rgba(58,85,224,.55))` : "none",
      }}
    />
  );
}
